import React from 'react';

const Loading = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-100 to-gray-200 p-4 flex justify-center items-center">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-6"></div>
        <p className="text-xl font-medium text-gray-700">Načítám cvičení...</p>
      </div>
    </div>
  );
};

export default Loading;
